module.exports = __webpack_public_path__ + "assets/ed91df32fa7cf705147932747594ba1c.svg";